// src/hooks/useSiteConfig.js
import { useState, useEffect, useCallback } from 'react';

const DEFAULTS = {
  socialLinks: { facebook: 'https://www.facebook.com/profile.php?id=61570762256091', twitter: '', linkedin: '', github: '', instagram: '' },
  bannerImageUrl: '',
  logoUrl: '/logo.png',
};

export function useSiteConfig() {
  const [config, setConfig] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/config');
      if (res.ok) {
        const data = await res.json();
        setConfig({ ...DEFAULTS, ...data });
      }
    } catch {
      // fall back to defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { config, loading, refresh, setConfig };
}
